import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import useAuth from '@/hooks/useAuth'; // Importamos el hook
import useFeedbackStore from '@components/ui/general/feedback/FeedbackStore';
import { ChevronDown, ChevronUp, ArrowLeft, LogOut } from 'lucide-react';
import classnames from 'classnames';
import DebugPanel from '@components/developer/ui/DebugPanel';

import './MainMenu.css';

function MainMenu() {
  // Obtenemos todo lo que necesitamos de nuestro hook central
  const { user, logout, isLoggingOut } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  
  // Show back button only when not on dashboard
  const showBackButton = location.pathname !== '/' && location.pathname !== '/dashboard';
  
  const { isHistoryVisible, toggleHistory, messages } = useFeedbackStore();
  const latestMessage = messages.length > 0 ? messages[messages.length - 1] : null;
  const feedbackClasses = classnames('feedback-text', latestMessage && `feedback-${latestMessage.type}`);
  
  const handleBackToDashboard = () => {
    navigate('/');
  };
  
  if (!user) return null;

  return (
    <nav className="main-menu">
      <div className="menu-logo-container">
        <img 
          src="/assets/logosimple.png" 
          alt="Xhelos 2" 
          className="menu-logo" 
          onClick={() => navigate('/dashboard')}
          style={{ cursor: 'pointer' }}
        />
        <DebugPanel />
      </div>
      <div className="feedback-display">
        {latestMessage ? (
          <span className={feedbackClasses} dangerouslySetInnerHTML={{ __html: latestMessage.message }} />
        ) : (
          <span>Welcome, {user?.name || 'User'}!</span>
        )}
      </div>

      <div className="menu-actions">
        <button onClick={toggleHistory} className="log-button icon-button" title={isHistoryVisible ? "Hide Log" : "Show Log"}>
          {isHistoryVisible ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
        </button>

         {showBackButton && (
          <button onClick={handleBackToDashboard} className="back-button">
            <ArrowLeft size={20} />
          </button>
        )}

        <button onClick={logout} className="logout-button" disabled={isLoggingOut}>
          <LogOut size={20} />
          {isLoggingOut ? 'Logging Out...' : ''}
        </button>
      </div>
    </nav>
  );
}

export default MainMenu;